export default __webpack_public_path__ + "static/media/gummies.d09f099a.png";